import { Box, Grid, Typography } from '@mui/material';
import { ts } from "src/utils/translate";
import { GetProjectResponseProject } from "src/model/api/v2/data-contracts";
import { ProjectsGridCard } from "src/pages/ProjectsPage/ProjectsGridCard";

type Props = {
    projects: GetProjectResponseProject[]
};

export function ProjectsGridView({ projects }: Props) {
    if (projects.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography color="text.secondary">
                    {ts('no_results_found', 'No results found.')}
                </Typography> 
            </Box>
        );
    }

    return (
        <Grid container spacing={3}>
            {projects.map((project) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={project.project.id}>
                    <ProjectsGridCard
                        extendedProject={project}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
